"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSectionItemsHandler = void 0;
var tslib_1 = require("tslib");
var general_1 = require("../../events/general");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var effects_1 = require("redux-saga/effects");
var layoutValidation_1 = require("./validation/layoutValidation");
var stashValidation_1 = require("./validation/stashValidation");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var layout_1 = require("../../store/layout");
var layout_2 = require("../../events/layout");
var arrayOps_1 = require("../../utils/arrayOps");
var insightsSelectors_1 = require("../../store/insights/insightsSelectors");
var redux_batched_actions_1 = require("redux-batched-actions");
var insights_1 = require("../../store/insights");
var itemValidation_1 = require("./validation/itemValidation");
var dashboardItemUtils_1 = require("../../utils/dashboardItemUtils");
function validateAndResolveItems(commandCtx) {
    var ctx = commandCtx.ctx, layout = commandCtx.layout, stash = commandCtx.stash, items = commandCtx.items, _a = commandCtx.cmd.payload, sectionIndex = _a.sectionIndex, itemIndex = _a.itemIndex;
    if (!layoutValidation_1.validateSectionExists(layout, sectionIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.cmd, "Attempting to add items to non-existing layout section at index " + sectionIndex + ".");
    }
    var section = layout.sections[sectionIndex];
    if (!layoutValidation_1.validateItemPlacement(section, itemIndex)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.cmd, "Attempting to insert new item at wrong index " + itemIndex + ". There are currently " + section.items.length + " items.");
    }
    var stashValidationResult = stashValidation_1.validateAndResolveStashedItems(stash, items);
    if (!isEmpty_1.default(stashValidationResult.missing)) {
        throw general_1.invalidArgumentsProvided(ctx, commandCtx.cmd, "Attempting to use non-existing stashes. Identifiers of missing stashes: " + stashValidationResult.missing.join(", "));
    }
    return {
        stashValidationResult: stashValidationResult,
        section: section,
    };
}
function addSectionItemsHandler(ctx, cmd) {
    var items, commandCtx, _a, _b, stashValidationResult, section, _c, itemIndex, sectionIndex, autoResolveDateFilterDataset, normalizationResult, itemsToAdd;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                items = cmd.payload.items;
                _a = {
                    ctx: ctx,
                    cmd: cmd,
                    items: dashboardItemUtils_1.addTemporaryIdentityToWidgets(items)
                };
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectLayout)];
            case 1:
                _a.layout = _d.sent();
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectStash)];
            case 2:
                _a.stash = _d.sent();
                return [4 /*yield*/, effects_1.select(insightsSelectors_1.selectInsightsMap)];
            case 3:
                commandCtx = (_a.availableInsights = _d.sent(),
                    _a);
                _b = validateAndResolveItems(commandCtx), stashValidationResult = _b.stashValidationResult, section = _b.section;
                _c = cmd.payload, itemIndex = _c.itemIndex, sectionIndex = _c.sectionIndex, autoResolveDateFilterDataset = _c.autoResolveDateFilterDataset;
                return [4 /*yield*/, effects_1.call(itemValidation_1.validateAndNormalizeWidgetItems, ctx, stashValidationResult, cmd)];
            case 4:
                normalizationResult = _d.sent();
                return [4 /*yield*/, effects_1.call(itemValidation_1.validateAndResolveItemFilterSettings, ctx, cmd, normalizationResult, autoResolveDateFilterDataset)];
            case 5:
                itemsToAdd = _d.sent();
                return [4 /*yield*/, effects_1.put(redux_batched_actions_1.batchActions([
                        insights_1.insightsActions.addInsights(normalizationResult.resolvedInsights.loaded),
                        layout_1.layoutActions.addSectionItems({
                            sectionIndex: sectionIndex,
                            itemIndex: itemIndex,
                            items: itemsToAdd,
                            usedStashes: stashValidationResult.existing,
                            undo: {
                                cmd: cmd,
                            },
                        }),
                    ]))];
            case 6:
                _d.sent();
                return [2 /*return*/, layout_2.layoutSectionItemsAdded(ctx, sectionIndex, arrayOps_1.resolveIndexOfNewItem(section.items, itemIndex), stashValidationResult.resolved, stashValidationResult.existing, cmd.correlationId)];
        }
    });
}
exports.addSectionItemsHandler = addSectionItemsHandler;
//# sourceMappingURL=addSectionItemsHandler.js.map